<template>
  <div class="order" style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">支付</p>
      </div>
    </header>
    <div class="center">
      <p>需要支付金额：<span style="color:#ee0a24;font-weight: 600">￥{{number}}</span></p>
    </div>
    <div class="">
      <!--<p>需要支付金额：<span style="color:#ff6034">￥{{number}}</span></p>-->
      <div class="payWie">
        <p class="weixin"><span><img style="width: 20px" src="@/assets/img/weixin.png" alt=""></span>
        <span>微信支付</span>
        </p>
       <span style="display: flex">
         <van-radio-group v-model="radio" checked-color="#ee0a24">
            <van-radio name="1"></van-radio>
  <!--<van-radio name="2">单选框 2</van-radio>-->
         </van-radio-group>
       </span>
      </div>
    </div>
    <div style="background:#e4e4e4;padding: 1.5rem 0">
      <!--<div style="margin: auto">-->
      <img  style="width: 80px;display: block;margin: auto" src="@/assets/img/lick.png" alt="">
      <!--</div>-->
      <div class="lickDiv">
        <div class="shopDetail" v-for="(item,index) in list" @click="toShopDetail(item.id)" >
          <div class="shopDiv">
            <img :src="item.img" alt="">
          </div>
          <div class="shopMessage">
            <span class="shopMessageName" >{{item.title}}</span>
            <span class="shopMessagePrice"><span style="color: #ff2500">￥{{item.price }}</span>
              <!--<span class="shopMessageF">{{item.sales_volume}} 付款</span></span>-->
            <span class="shopMessageF"><van-icon color="" size="18" name="shopping-cart-o" /></span></span>
          </div>
        </div>

      </div>
    </div>
    <!--<van-submit-bar :price="3050"  button-text="提交订单" >-->
    <!--<p>共计</p>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050" button-text="提交订单" @submit="onSubmit">-->
    <!--<van-checkbox v-model="checked">全选</van-checkbox>-->
    <!--<template #tip>-->
    <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
    <!--</template>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050"   />-->
    <!--<p @click="saveCart">code</p>-->
    <!--<div class="inforName">-->
      <!--<van-button style="width:100%;height:2.5rem" color="red" type="primary" @click="Wxpay">立即支付</van-button>-->
    <!--</div>-->
    <van-submit-bar  button-text="支付" @submit="Wxpay" button-color="linear-gradient(to right,#ffd01e,#ee0a24)">
      <template #default>
        <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
        <p class="orderBottom"> <span style="color: #dedede">共{{$route.query.count}}件</span>
          <span style="color: #f56723">合计:￥{{$route.query.id}}</span>
        </p>
        <!--<button class="button">提交订单</button>-->
      </template>
    </van-submit-bar>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        list:[],
        address:{},
        number:"",
        code:"",
        order:"",
        radio:"1",
        orderId:""
      }
    },
    created(){

    },
    methods: {
      backHistory(){
        this.$dialog.alert({
          title: '确认离开支付中心？',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$router.push({
            path:"/allOrder"
          })
        });

      },
      shopLister(){ //推荐商品
        this.$api.shopList()
          .then(res=>{
            console.log(res.data)
            for(let i=0;i<10;i++){
              this.list.push(res.data[i])
            }
//            this.list=res.data
            console.log(this.list)
          })
      },
      toAddress(){
        this.$router.push("/harvestAddress")
      },

      _totalPeice () {
        console.log(this.$route.query)
        this.number = this.$route.query.id
        this.orderId = this.$route.query.pintuan_tid
        this.allCount = ""
      },
      Wxpay(){
        let _this=this
        this.$api.Wxpay({
          code:this.code,
          order_number:localStorage.getItem("order"),
          user_id:localStorage.getItem("userid"),
        }).then(res=>{
          var data=JSON.parse(res)


          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":data.appId,     //公众号名称，由商户传入
              "timeStamp":data.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":data.nonceStr, //随机串
              "package":data.package,
              "signType":data.signType,         //微信签名方式：
              "paySign":data.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
                if(localStorage.getItem("orderTid")=="null"){
                  _this.$router.push({
                    path:"/allOrder",
                  })

                }else {
                  _this.$router.push({
                    path:"/collagePayHome",
                    query:{
                      oderTid:_this.$route.query.pintuan_tid
                    }
                  })
//                  window.location.href="https://m.shangshebao.com/shop/#/allOrder"
                }
              }else {

                // 支付失败跳转
                window.location.href="https://m.shangshebao.com/shop/#/allOrder"
              }
            });
//          console.log(data)
//          alert(JSON.stringify(res))
//          alert(data.appId)
//          alert(data.timeStamp)
//          alert(data.nonceStr)
//          alert(data.package)
//          alert(data.signType)
//          alert(data.paySign)

        }).catch(res=>{
          window.location.href="https://m.shangshebao.com/shop/#/allOrder"
        })
      },
      saveCart(){
        let code=this.$route.query.id
        let href="https://m.shangshebao.com/shop/#/orderPay?id="+code+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
//        let href="http://new.shangshebao.com/phone/shangshebao/shop/#/orderPay?id="+code+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
        let Jumpurl = encodeURIComponent(href);
        this.code = this.getUrlParam('code');
        if (this.code==null) {
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7bd203a60100c6d4&redirect_uri="+Jumpurl+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
        }

      },
      getUrlParam (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = window.location.href.split('#')[0]
        let search = url.split('?')[1]
        if (search) {
          var r = search.substr(0).match(reg)
          if (r !== null) return unescape(r[2])
          return null
        } else {
          return null
        }
      }
    },
    mounted(){
      this._totalPeice()
      this.saveCart()
      this.shopLister()
    }
  }
</script>

<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 60px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .order{
    width: 100%;
    height: 100%;
    background: #E4E4E4;
    padding-top: 70px;
  }
  .center{
    width: 100%;
    height: 5rem;
    /*background: #ffffff;*/
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .center p{
    /*font-size: 15px;*/

  }
  .inforName{
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
  }
  .payWie{
    display: flex;
    align-items: center;
    background: #ffffff;
    padding: 15px 1rem;
    justify-content: space-between;
    margin: 0 13px;
    border-radius: 10px;
  }
  .weixin{
    display: flex;
  }
  .weixin span{
    margin-left: 10px;
    font-size: 15px;
  }
  .orderBottom{
    flex: 1;

  }
  .orderBottom span{
    margin-left: 1rem;
  }
  /deep/.van-submit-bar__bar{
    padding: 0 1rem;
  }

  /*猜你喜欢*/
  .lickDiv{
    display:flex ;
    flex-wrap:wrap;
    background: #e4e4e4;
    margin-bottom: 35px;
    padding-bottom: 10px;
    /*justify-content: center;*/
  }
  .shopDiv{
    width: 100%;
    /*height: 120px;*/
    /*background: #6e9bcf;*/
    border-radius: 1rem;
    /*margin-left: 1px;*/
    /*margin: 10px;*/
  }
  .shopDiv img{
    width: 100%;
    /*height: 100%;*/
  }
  .shopDetail{
    /*width: 40%;*/
    /*margin: 8px 5%;*/
    /*color: #898888;*/

    width: 40%;
    margin: 8px 0 1% 4%;
    color: #898888;
    background: #ffffff;
    padding: 3%;
    margin-left: 10px;
  }
  .shopMessageName{
    display: block;
    color: #898888;
  }
  .shopMessagePrice{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shopMessage span{
    padding-top: 2px;
  }
  .shopMessageName:first-child{
    /*font-size: 18px;*/
  }
  .shopMessageName:last-child{
    /*font-size: 12px;*/
  }
  .shopMessageF{
    font-size: 12px;
    margin-left: 10px;
  }
  .shopMessage{
    /*text-align: center;*/
  }
  .messageLine{
    text-decoration: line-through;
    margin-left: 10px;
  }
  .shopMessage{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/orderPay.vue